module.exports = __webpack_public_path__ + "img/7.4c18337e.png";